import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorAuthenticationGuard  {
  constructor(private _router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const is2FA = JSON.parse(localStorage.getItem('2FA') || '{}');
    if (is2FA == true) {
      return true;
    } else {
      this._router.navigate(['/login']);
      return false;
    }
  }

}
